import type { PermissionExpr } from './check'

/**
 * Literais das permissions de disparo (`app/permissions/permissions.py::DispatchesPermissions`).
 *
 * Existe como const pelo mesmo motivo de [[transmission]]: o contract test de
 * `literals.test.ts` só alcança CONSTS, e `check.ts` faz `includes()` exato —
 * não há wildcard `dispatches:*`, então literal errado é fail-closed e MUDO (o
 * item de menu some sem erro nenhum).
 */
export const DISPATCHES_PERMISSIONS = {
  /** `GET /whatsapp/dispatches` e o detalhe. Gate do item "Ir para o disparo". */
  READ: 'dispatches:read',
  CREATE: 'dispatches:create',
  /** RECOUNT, não edição — fora de todo preset que não seja `owner`. */
  UPDATE: 'dispatches:update',
  /** "Reaproveitar público" do detalhe do disparo — PREMIUM, fora de todo preset (só o
   *  dstorres concede). Nenhuma rota a exige: é o gate da seção e do kebab do kanban,
   *  SOMADO às permissions de disparo/lista de cada ação. */
  AUDIENCE_REUSE: 'dispatches:audience:reuse',
} as const

/**
 * As abas do Resumo da tela de disparos (faixa 38), espelho de
 * `app/permissions/permissions.py::DispatchAnalyticsPermissions` (:251-254). UMA por aba,
 * pra liberar parcial; fora de todo preset (por ora só o dstorres, que recebe todas).
 *
 * **Nenhuma exige `dispatches:read` junto**: a aba é a VIEW e a permission dela é o
 * acesso. Por isso o rail aceita qualquer das cinco (`DISPATCHES_RAIL_ACCESS`) e o back
 * libera as opções da faixa de filtros pra quem tem só uma destas.
 */
export const DISPATCH_ANALYTICS_PERMISSIONS = {
  /** `GET /whatsapp/dispatches/stats/overview` — seção Visão geral. */
  OVERVIEW_READ: 'dispatches:analytics:overview:read',
  /** `GET /whatsapp/dispatches/stats/engagement` — seção Engajamento (teto de 92 dias). */
  ENGAGEMENT_READ: 'dispatches:analytics:engagement:read',
  /** `GET /whatsapp/dispatches/stats/rankings` — seção Templates e remetentes. */
  RANKINGS_READ: 'dispatches:analytics:rankings:read',
  /** `GET /whatsapp/dispatches/stats/failures` — seção Falhas (teto de 92 dias). */
  FAILURES_READ: 'dispatches:analytics:failures:read',
} as const

/**
 * Quem entra em `/chatbot/dispatches`: a Lista (`dispatches:read`) OU qualquer seção do
 * Resumo. Sem as analytics aqui, quem recebeu só uma aba do Resumo nunca chegaria à tela.
 */
export const DISPATCHES_RAIL_ACCESS: PermissionExpr = {
  or: [DISPATCHES_PERMISSIONS.READ, ...Object.values(DISPATCH_ANALYTICS_PERMISSIONS)],
}
